import { permissions } from "./auth/config";

export interface Auth {
    required?: string[];
    oneOf?: string[];
}

export interface rbacItem {
    auth?: Auth;
    badge?: {
        variant: string;
        text: string;
    };
    children?: {};
    icon: string;
    name: string;
    url: string;
}

interface navConfig {
    items: rbacItem[];
}

const navItems: navConfig = {
    items: [
        {
            badge: {
                variant: "primary",
                text: "",
            },
            icon: "fa fa-bar-chart",
            name: "Dashboard",
            url: "/dashboard",
            auth: permissions.dashboard,
        },
        {
            badge: {
                variant: "primary",
                text: "",
            },
            icon: "fa fa-line-chart",
            name: "BI & Analytics",
            url: "/analytics",
            auth: permissions.dashboard,
            children: [
                {
                    name: "Order Reports",
                    url: "/analytics/orderReport",
                    auth: permissions.dashboard,
                },
                {
                    name: "Payment Reports",
                    url: "/analytics/paymentReport",
                    auth: permissions.dashboard,
                },
                // {
                //   icon:"fa fa-sitemap",
                //   name:"Item Reports",
                //   url:"/analytics/itemReport",
                // auth: permissions.dashboard,
                // },
                {
                    name: "Partner Reports",
                    url: "/analytics/partnerReport",
                    auth: permissions.dashboard,
                },
                // {
                //   icon:"fa fa-cube",
                //   name:"Refund Reports",
                //   url:"/analytics/refundReport",
                // auth: permissions.dashboard,
                // },
                {
                    name: "Commission Reports",
                    url: "/analytics/commissionReport",
                    auth: permissions.dashboard,
                },
                // {
                //   name: "Service Request Reports",
                //   url: "/analytics/serviceRequestReport",
                // auth: permissions.dashboard,
                // },
                // {
                //   icon:"fa fa-exchange",
                //   name:"Inventory Reports",
                //   url:"/analytics/inventoryReport",
                // auth: permissions.dashboard,
                // },
                // {
                //   icon:"fa fa-list-alt",
                //   name:"Invoice Reports",
                //   url:"/analytics/invoiceReport",
                // auth: permissions.dashboard,
                // },
                // {
                //   name: "Delivery Charge Reports",
                //   url: "/analytics/deliveryChargeReport",
                // auth: permissions.dashboard,
                // },
                {
                    name: "Daily Registration",
                    url: "/analytics/dailyRegistration",
                    auth: permissions.dashboard,
                },
                // {
                //   name: "Work Reports",
                //   url: "/analytics/workReports",
                //   auth: permissions.dashboard,
                // },
            ],
        },
        {
            name: "Attribute",
            url: "/attribute",
            icon: "fa fa-cube",
            auth: permissions.attribute,
        },
        {
            name: "Catalog",
            url: "/catalog",
            icon: "fa fa-calendar-minus-o",
            auth: permissions.catalog,
        },
        {
            name: "Tenant",
            icon: "fa fa-user-plus",
            url: "/tenant",
            auth: permissions.tenant,
        },
        {
            name: "Item",
            url: "/item",
            icon: "fa fa-sitemap",
            auth: permissions.item,
        },
        {
            name: "Inventory",
            url: "/inventory",
            icon: "fa fa-exchange",
            auth: permissions.inventory,
        },
        {
            name: "Partner",
            url: "/partner",
            icon: "fa fa-handshake-o",
            auth: permissions.partner,
        },
        {
            name: "Channel",
            icon: "fa fa-share-alt",
            url: "/leads",
            auth: permissions.advertisement,
            children: [
                {
                    name: "Leads",
                    icon: "fa fa-user-plus",
                    url: "/channels/leads",
                    auth: permissions.advertisement,
                },
                {
                    name: "Content Management",
                    icon: "fa fa-file-text-o",
                    url: "/channels/contentManagement",
                    auth: permissions.advertisement,
                },
            ],
        },
        {
            name: "Bulk Notification",
            icon: "fa fa-bell",
            url: "/listOfCriteria",
            auth: permissions.bulkNotification,
        },
        {
            name: "Role",
            icon: "fa fa-graduation-cap",
            url: "/role",
            auth: permissions.role,
        },
        {
            name: "Permission",
            icon: "fa fa-lock",
            url: "/permission",
            auth: permissions.permission,
        },
        {
            name: "Features",
            icon: "fa fa-unlock",
            url: "/features",
            auth: permissions.feature,
        },
        {
            name: "User Management",
            icon: "fa fa-address-card",
            url: "/user",
            auth: permissions.sub_tenant,
        },
        // {
        //   name: 'Service Request',
        //   icon: 'icon-puzzle',
        //   url: '/service-request',
        //   auth: permissions.serviceRequest,
        // },
        {
            name: "Office Management",
            icon: "fa fa-briefcase",
            url: "/office-management",
            auth: permissions.office_org,
        },
        // {
        //     name: "Customer Onboard",
        //     icon: "fa fa-users",
        //     url: "/customers",
        //     auth: permissions.onboardCustomer,
        // },
        {
            name: "Portfolio Management",
            icon: "fa fa-user",
            url: "/portfolio",
            auth: permissions.unitManagement,
        },
        {
            name: "Unit Management",
            icon: "fa fa-home",
            url: "/unit",
            auth: permissions.unitManagement,
        },
        {
            name: "Stock Point",
            icon: "fa fa-building-o",
            url: "/suboffice-management",
            auth: permissions.suboffice_org,
        },
        {
            name: "Order Management",
            icon: "fa fa-shopping-cart",
            url: "/manage-order",
            auth: permissions.orders_management,
        },
        // {
        //   name: 'Offer-image',
        //   icon: 'fas fa-images',
        //   url: '/offerimage',
        //   auth: permissions.offerImage,
        // },
        // {
        //     name: "Commission",
        //     icon: "fa fa-percent",
        //     url: "/commission",
        //     auth: permissions.commission,
        // },
        // {
        //   name: 'Discount & Coupons',
        //   icon: 'fa fa-credit-card',
        //   url: '/discount-coupon',
        //   auth: permissions.discount_coupons,
        // },
        {
            name: "Subscription",
            icon: "fa fa-money",
            url: "/subscription-pricing",
            auth: permissions.subscription_pricing,
        },
        // {
        //   name: "Promotions",
        //   icon: "fa fa-bullhorn",
        //   url: "/promotions",
        //   auth: permissions.promotion,
        // },
        // {
        //   name: "Manage Team",
        //   icon: "fa fa-group",
        //   url: "/manage-team",
        //   auth: permissions.manage_team
        // },
        {
            name: "Payment History",
            icon: "fa fa-history",
            url: "/payment-history",
            auth: permissions.payment_history,
        },
        {
            name: "Notification Approval",
            icon: "fa fa-bell",
            url: "/approvalNotification",
            auth: permissions.approvalNotification,
        },
        {
            name: "Approvals",
            icon: "fa fa-check",
            url: "/approvals",
            auth: permissions.approval,
        },
        // {
        //   name: "Apply Promo",
        //   icon: "fa fa-bullhorn",
        //   url: "/applyPromo",
        //   auth: permissions.applyPromo,
        // },
        {
            name: "Bulk Promotion",
            icon: "fa fa-bullhorn",
            url: "/bulkPromotion",
            auth: permissions.bulkPromotion,
        },
        {
            name: "Customer Management",
            icon: "fa fa-user",
            url: "/customer-management",
            auth: permissions.customer_management,

        },
        {
            name: "Business Plan",
            icon: "fa fa-handshake-o",
            url: "/businessPlan",
            auth: permissions.businessPlan,
        },
        {
            name: "Manage Own Customer",
            icon: "fa fa-users",
            url: "/manage_own_customer",
            auth: permissions.manage_own_customer,
        },
        {
            icon: "fa fa-envelope",
            url: "/notification-template",
            name: "Notification Template",

        },
        {
            name: "Setup",
            icon: "fa fa-wrench",
            url: "/setup",
            auth: permissions.setup,
            children: [
                {
                    name: "Resources",
                    url: "/setup/Resources",
                    auth: permissions.Resources,
                },
                {
                    name: "Concern",
                    url: "/setup/concern",
                    auth: permissions.concern,
                },
                {
                    name: "Faq",
                    url: "/setup/faq",
                    auth: permissions.FAQSetup,
                },
                {
                    name: "Tax Code",
                    url: "/setup/taxcode",
                    auth: permissions.taxcodeSetup,
                },
                {
                    name: "Coupon & Promotion",
                    url: "/setup/Coupon",
                    auth: permissions.couponSetup,
                },
                {
                    name: "Subscription Plan",
                    url: "/setup/subscriptionplan",
                    auth: permissions.subscriptionplan,
                },
                {
                    name: "Access Rule",
                    url: "/setup/accessrule",
                    auth: permissions.accessrule,
                },
                {
                    name: "Delivery Setup",
                    url: "/setup/deliverysetup",
                    auth: permissions.deliverysetup,
                },
                {
                    url: "/setup/commission",
                    name: "Commission Setup",
                    auth: permissions.commissionSetup,
                },
                {
                    url: "/setup/service-request",
                    name: "Service Request",
                    auth: permissions.serviceRequestSetup,
                },
                {
                    name: "Return & Cancellation Policy",
                    url: "/setup/policy",
                    auth: permissions.tenant,
                },
                {
                    name: "Workflows",
                    url: "/setup/workflows",
                    auth: permissions.tenant,
                },
            ],
        },
        {
            name: "Advertisement",
            icon: "fa fa-bullhorn",
            url: "/advertisement",
            auth: permissions.advertisement,
        },
        {
            name: "Service Ticket",
            icon: "fa fa-ticket",
            url: "/serviceticket",
            auth: permissions.service_ticket,
            children: [
                {
                    name: "Customer Open tickets",
                    url: "/serviceticket/open",
                    auth: permissions.service_ticket,
                },
                {
                    name: "Customer Close tickets",
                    url: "/serviceticket/close",
                    auth: permissions.service_ticket,
                },
            ],
        },
        {
            name: "FAQS",
            icon: "fa fa-question-circle",
            url: "/faq",
            auth: permissions.faq,
        },
        {
            name: "Privacy Setting",
            icon: "fa fa-lock",
            url: "/privacy-setting",
            auth: permissions.faq,
        },
        {
            name: "Customer",
            url: "/customer",
            icon: "fa fa-users",
            auth: permissions.customer,
        },
        // {
        //   name: "SubScription Assign",
        //   url: "/subcription-assign",
        //   icon: "fa fa-handshake-o",
        //   auth: permissions.partner
        // },
        {
            name: "Employee Feedback",
            url: "/feedback",
            icon: "fa fa-commenting",
            auth: permissions.orders_management,
        },
        {
            name: "Q&A Configuration",
            url: "/survey",
            icon: "fas fa-poll",
            auth: permissions.orders_management,
        },
        {
            name: "Contact Us Enquiries",
            url: "/contact-us-enquiries",
            icon: "fas fa-question",
            auth: permissions.orders_management,
        },
    ],
};

export default navItems;
